import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda pro založení nového produktu pod projektem. Produkt vzniká zároveň s první sérií,
 * proto formulář kombinuje pole produktu (Název produktu) a pole série.
 * Otevírá se z plus akce na řádku projektu ve stromu; `projectId` určuje nadřazený projekt.
 */
export const productFormAgenda = defineAgenda({
  id: 'app.venua-planner.product-form',
  path: 'app/venua-planner/product',
  open: {
    projectId: param.uuid(),
  },
  title: 'Nový produkt',
  icon: 'box',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
